export default __webpack_public_path__ + "static/media/instagram.6bb58987.png";